import { selectAllInvitations } from "@organizations/store/selectors/invitation.selectors";
import { selectAllLocations } from "@organizations/store/selectors/location.selectors";
import { selectAllOrganizations } from "@organizations/store/selectors/organization.selectors";
import { selectAllOus } from "@organizations/store/selectors/ou.selectors";
import { selectAllRoleAssignments } from "@organizations/store/selectors/role-assignment.selectors";
import { createSelector } from "@ngrx/store";

export const selectAllMails = createSelector(
  selectAllRoleAssignments,
  selectAllInvitations,
  (roleAssignments, invitations) => {
    // Return a set of mail addresses from the role assignments and invitations.
    return new Set([
      ...roleAssignments.map((roleAssignment) => roleAssignment.assignee.mail),
      ...invitations.map((invitation) => invitation.inviteeMailAddress)
    ]);
  }
);

export const selectAllOrganizationsLocationsOus = createSelector(
  selectAllOrganizations,
  selectAllLocations,
  selectAllOus,
  (organizations, locations, ous) => {
    // Return a map of named entities (values) by scope (keys).
    return {
      organizations,
      locations,
      ous
    };
  }
);
